export default {
      id: "i-arrow-right4-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right4",
      toString: function () {
        return this.url;
      }
    }